import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../../pages/Dashboard";
import NotFound404 from "../../pages/error/NotFound404";

const SuperAdminRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/*" element={<NotFound404 />} />
    </Routes>
  );
};

export default SuperAdminRoutes;
